import styled from 'styled-components';

export const DateStyles = styled.div`
  color: ${({ theme }) => theme.colors.limedSpruce};
  font-size: ${({ theme }) => theme.fontSize.sm};
  opacity: 0.5;
  white-space: nowrap;
`;
